import React from 'react';
import { motion } from 'framer-motion';
import { targetAudiences } from '../data/mockData';
import { Rocket, ShoppingCart, Package, Palette, Lightbulb, Building } from 'lucide-react';

const iconMap = { Rocket, ShoppingCart, Package, Palette, Lightbulb, Building };

const WhoNeedsSection = () => {
  return (
    <section data-testid="who-needs-section" className="py-28 relative">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div className="max-w-3xl mb-16" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#3B82F6]/10 border border-[#3B82F6]/20 mb-5">
            <span className="text-xs font-semibold text-[#3B82F6] uppercase tracking-wider">Who Needs This</span>
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-white mb-5">
            Logo Trademark Protection <span className="text-gradient">for Everyone</span>
          </h2>
          <p className="text-lg text-[#A1A1AA] leading-relaxed">
            Whether you're just starting out or scaling an established brand, trademark protection is essential.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {targetAudiences.map((audience, index) => {
            const IconComp = iconMap[audience.icon];
            return (
              <motion.div key={audience.id}
                className="glass-card rounded-2xl p-7 group hover:border-[#3B82F6]/30 transition-all duration-300"
                initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: index * 0.05 }}>
                <div className="w-11 h-11 rounded-xl bg-[#3B82F6]/10 flex items-center justify-center mb-5 group-hover:bg-[#3B82F6]/20 transition-colors icon-hover">
                  {IconComp && <IconComp className="w-5 h-5 text-[#3B82F6]" />}
                </div>
                <h3 className="font-heading text-lg font-semibold text-white mb-2">{audience.title}</h3>
                <p className="text-sm text-[#A1A1AA] leading-relaxed">{audience.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhoNeedsSection;
